import React, {CSSProperties} from 'react';
import styled from 'styled-components';
import IconList from '../assets/svgs/IconList';

export type IconName = keyof typeof IconList;
export interface IconPropsBase extends React.HTMLAttributes<HTMLSpanElement> {
  icon: IconName;
  size?: number;
  block?: boolean;
  fill?: string;
  style?: CSSProperties;
  className?: string;
  stroke?: string;
  rectFill?: string;
}

export type IconProps = IconPropsBase;

const IconComponent = styled.span<Omit<IconProps, 'type' | 'icon'>>`
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
  vertical-align: -0.125em;
  svg {
    ${(props) =>
      props.fill && `fill: ${props.fill}; path {fill: ${props.fill};}`}
    ${(props) => props?.stroke && `path {stroke: ${props?.stroke}}`}
    ${(props) => props?.rectFill && `rect {fill: ${props?.rectFill}}`}
    ${(props) =>
      props.size
        ? `width: ${props.size}px; height: ${props.size}px;`
        : `width: 1em; height: 1em;`}
  }
`;

const Icon = (props: IconProps) => {
  const {size, className, style, block, icon, fill, stroke, rectFill, ...rest} =
    props;

  const SpecificComponent =
    IconList[icon] !== undefined ? (
      IconList[icon]
    ) : (
      <img src={icon} alt="icon" />
    );

  return (
    <IconComponent
      size={size}
      className={`icon ${className ? className : ''}`}
      style={style}
      block={block}
      stroke={stroke}
      fill={fill}
      rectFill={rectFill}
      {...rest}
    >
      {SpecificComponent && SpecificComponent}
    </IconComponent>
  );
};

export default Icon;
